import styled from 'styled-components';

export const SnowflakeSection = styled.div`
  margin-bottom: ${({ theme }) => theme.x2space}rem;

  ul {
    list-style: disc;
    padding-left: 21px;
  }
`;

export const BoldText = styled.span`
  font-weight: bold;
`;
